<template>
  <div class="tun-network">
    <!-- 首屏 banner -->
    <div class="section-banner">
      <div class="banner-main">
        <div class="banner-title move">异地组网</div>
        <div class="banner-subtitle move delay-100">
          随时随地，全设备互通互联
        </div>
        <div class="banner-desc move delay-200">
          通过绑定设备即自动组网，账户下的设备可通过组网地址互通互联，支持自定义组网与网段组网，轻松访问远程局域网的设备与服务。
        </div>
        <div class="banner-btns">
          <div class="btn-primary" @click="goDownload">立即体验</div>
          <div class="btn-ghost" @click="goDoc">查看文档</div>
        </div>
        <img class="banner-pic" :src="bannerTun" alt="" />
        <div class="banner-features">
          <div class="feature-item">
            <img class="feature-icon" :src="bannerAuto" alt="" />
            <div class="feature-text">
              <div class="feature-title">自动组网</div>
              <div class="feature-sub">绑定即连，无需配置</div>
            </div>
          </div>
          <div class="feature-item">
            <img class="feature-icon" :src="bannerP2p" alt="" />
            <div class="feature-text">
              <div class="feature-title">P2P直连</div>
              <div class="feature-sub">高速稳定，不限流量</div>
            </div>
          </div>
          <div class="feature-item">
            <img class="feature-icon" :src="bannerLock" alt="" />
            <div class="feature-text">
              <div class="feature-title">安全加密</div>
              <div class="feature-sub">端到端加密，隐私保护</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 核心优势 -->
    <div class="section-adv">
      <div class="adv-main">
        <div class="section-title move">核心优势</div>
        <div class="section-sub move delay-100">轻松管理多节点网络</div>
        <div class="adv-grid">
          <div
            class="adv-card move"
            v-for="(item, index) in advList"
            :key="item.title"
            :style="{ transitionDelay: index * 0.1 + 's' }"
          >
            <img class="adv-icon" :src="item.icon" alt="" />
            <div class="adv-title">{{ item.title }}</div>
            <div class="adv-desc" v-html="item.desc"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 组网方案（深色区） -->
    <div class="section-plan">
      <div class="plan-main">
        <div class="section-title move">组网方案</div>
        <div class="section-sub move delay-100">极致简单，安全访问</div>
        <div class="plan-grid">
          <div
            class="plan-card move"
            v-for="(item, index) in planList"
            :key="item.title"
            :style="{ transitionDelay: index * 0.1 + 's' }"
          >
            <div class="plan-top">
              <img :src="item.img" alt="" />
            </div>
            <div class="plan-title">{{ item.title }}</div>
            <div class="plan-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 应用场景 -->
    <div class="section-scene">
      <div class="scene-main">
        <div class="section-title move">应用场景</div>
        <div class="scene-grid">
          <div
            class="scene-card move"
            v-for="(item, index) in sceneList"
            :key="item.title"
            :style="{ transitionDelay: index * 0.1 + 's' }"
          >
            <div class="scene-img-wrap">
              <img :src="item.img" alt="" />
            </div>
            <div class="scene-title">{{ item.title }}</div>
            <div class="scene-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 CTA -->
    <div class="section-cta">
      <img class="cta-overlay" :src="ctaOverlay" alt="" />
      <div class="cta-main">
        <div class="cta-title">立即开始你的异地组网之旅</div>
        <div class="cta-sub">
          绑定设备，立即自动组网，享受高清、安全、稳定的互联体验
        </div>
        <div class="btn-primary cta-btn" @click="goDownload">免费体验</div>
      </div>
    </div>

    <Foot></Foot>
  </div>
</template>

<script>
  import Foot from '@/components/Foot.vue'

  export default {
    name: 'TunNetwork',
    components: {
      Foot,
    },
    data: function () {
      return {
        bannerAuto: require('@/assets/introduce/banner_auto.png'),
        bannerP2p: require('@/assets/introduce/banner_p2p.png'),
        bannerLock: require('@/assets/introduce/banner_lock.png'),
        bannerTun: require('@/assets/introduce/banner_tun.webp'),
        ctaOverlay: require('@/assets/introduce/cta_bg.png'),
        advList: [
          {
            icon: require('@/assets/introduce/adv_p2p.png'),
            title: 'P2P直连',
            desc: '点对点直连传输，最大可达带宽速率，不限流量',
          },
          {
            icon: require('@/assets/introduce/adv_data.png'),
            title: '数据安全',
            desc: '端到端加密传输，数据仅在设备之间传递，隐私更安心',
          },
          {
            icon: require('@/assets/introduce/adv_stable.png'),
            title: '稳定可靠',
            desc: '自研智能通道调度系统，网络切换自动恢复，连接更稳定',
          },
          {
            icon: require('@/assets/introduce/adv_easy.png'),
            title: '简单易用',
            desc: '登录即组网，无需网络配置，上手零门槛',
          },
          {
            icon: require('@/assets/introduce/adv_all.png'),
            title: '全平台支持',
            desc: '搭配小宝网关，支持市面99%<br>系统',
          },
        ],
        planList: [
          {
            img: require('@/assets/introduce/plan_auto.svg'),
            title: '自动组网',
            desc: '绑定设备即自动加入同一虚拟网络，自有设备通过组网地址互通互联',
          },
          {
            img: require('@/assets/introduce/plan_custom.svg'),
            title: '自定义组网',
            desc: '选择任一设备作为中转，访问其所在局域网内的其他设备与服务',
          },
          {
            img: require('@/assets/introduce/plan_map.svg'),
            title: '全网映射',
            desc: '将局域网段通过任一设备发布为组网段，异地设备可使用组网段访问',
          },
          {
            img: require('@/assets/introduce/plan_gateway.svg'),
            title: '小宝网关',
            desc: '让网关下的设备免端访问组网地址，或多网络互通互联',
          },
        ],
        sceneList: [
          {
            img: require('@/assets/introduce/scene_movie.webp'),
            title: '远程观影',
            desc: '流畅访问影音服务器，随时随地享受高清影视大片',
          },
          {
            img: require('@/assets/introduce/scene_file.webp'),
            title: '远程文件传输',
            desc: '不受地域限制，个人设备文件随时取用',
          },
          {
            img: require('@/assets/introduce/scene_game.webp'),
            title: '游戏串流',
            desc: '兼容 MoonLight & Sunshine 等串流工具， 低门槛畅玩游戏',
          },
          {
            img: require('@/assets/introduce/scene_industry.webp'),
            title: '远程工控调试',
            desc: '远程访问工控设备，实时调试与监控，提升运维效率',
          },
          {
            img: require('@/assets/introduce/scene_serial.webp'),
            title: '串口调试',
            desc: '远程访问串口设备，进行数据调试与设备通信',
          },
          {
            img: require('@/assets/introduce/scene_office.webp'),
            title: '远程办公',
            desc: '访问公司内网应用与资源，安全办公不受地点限制',
          },
          {
            img: require('@/assets/introduce/scene_ops.webp'),
            title: '运维管理',
            desc: '远程管理服务器、路由器、NAS等设备，高效运维，省时省力',
          },
          {
            img: require('@/assets/introduce/scene_smarthome.webp'),
            title: '智能家居访问',
            desc: '远程访问智能家居设备，随时掌控家中状态',
          },
        ],
      }
    },
    methods: {
      goDownload: function () {
        if (this.$route.path !== '/download') {
          this.$router.push('/download')
        }
      },
      goDoc: function () {
        window.open('https://iepose.com/helpcenter_v3/')
      },
      // 滚动检查：进入视口的 .move 元素加 move-active，触发入场动画（同首页模式）
      checkInView: function (animatedElements) {
        const windowHeight =
          window.innerHeight || document.documentElement.clientHeight
        animatedElements.forEach((element) => {
          const elementTop = element.getBoundingClientRect().top
          const elementBottom = element.getBoundingClientRect().bottom
          const isInView = elementTop < windowHeight - 100 && elementBottom > 0
          if (isInView) {
            element.classList.add('move-active')
          }
        })
      },
    },
    mounted: function () {
      const animatedElements = document.querySelectorAll('.move')
      // 首屏元素立即检查一次（页面刚加载时尚未触发 scroll，避免首屏内容空白）
      this.$nextTick(() => {
        this.checkInView(animatedElements)
      })
      window.addEventListener('scroll', () => {
        this.checkInView(animatedElements)
      })
    },
  }
</script>

<style scoped lang="less">
  .tun-network {
    width: 100%;

    .section-title {
      font-size: 40px;
      font-weight: 700;
      color: #1d1f24;
      text-align: center;
    }

    .section-sub {
      margin-top: 12px;
      font-size: 24px;
      line-height: 36px;
      color: #777e90;
      text-align: center;
    }

    .btn-primary {
      width: 160px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      color: #ffffff;
      font-size: 18px;
      border-radius: 8px;
      background: #3772ff;
      cursor: pointer;
    }

    .btn-primary:hover {
      opacity: 0.9;
    }

    /* ---------- 首屏 ---------- */
    .section-banner {
      padding-top: 122px;
      padding-bottom: 70px;
      // 横向渐变：左紫蓝 → 右暖紫
      background: linear-gradient(90deg, #daedff 0%, #e0eaff 50%, #e4daff 100%);

      .banner-main {
        width: 1280px;
        margin: 0 auto;
        position: relative;
      }

      // 首屏右侧插画：600x416，悬在文字区右侧
      .banner-pic {
        position: absolute;
        right: 40px;
        top: -48px;
        width: 600px;
        height: 416px;
      }

      .banner-title {
        width: fit-content;
        font-size: 64px;
        font-weight: 700;
        line-height: 72px;
        background: linear-gradient(
          90deg,
          #3772ff 0%,
          #aa56ff 35%,
          #ff6838 70%,
          #ff9924 100%
        );
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .banner-subtitle {
        margin-top: 13px;
        font-size: 44px;
        font-weight: 700;
        line-height: 66px;
        color: #1d1f24;
      }

      .banner-desc {
        margin-top: 9px;
        width: 521px;
        font-size: 20px;
        line-height: 29px;
        color: #6a7080;
      }

      .banner-btns {
        display: flex;
        margin-top: 33px;
      }

      .btn-ghost {
        margin-left: 36px;
        width: 160px;
        height: 48px;
        line-height: 46px;
        text-align: center;
        font-size: 18px;
        color: #3772ff;
        border: 1px solid #3772ff;
        border-radius: 8px;
        box-sizing: border-box;
        cursor: pointer;
      }

      .btn-ghost:hover {
        background: rgba(55, 114, 255, 0.08);
      }

      .banner-features {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 80px;
        height: 120px;
        padding: 0 67px;
        background: rgba(255, 255, 255, 0.4);
        border: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 20px;
        box-sizing: border-box;
        // 毛玻璃悬浮条：半透明白 + 背景模糊
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        box-shadow: 0 8px 24px rgba(23, 33, 94, 0.06);
      }

      .feature-item {
        display: flex;
        align-items: center;

        .feature-icon {
          width: 60px;
          height: 60px;
        }

        .feature-text {
          margin-left: 12px;

          .feature-title {
            font-size: 24px;
            font-weight: 700;
            line-height: 36px;
            color: #1d1f24;
          }

          .feature-sub {
            margin-top: 2px;
            font-size: 16px;
            line-height: 24px;
            color: #8a8f9e;
          }
        }
      }
    }

    /* ---------- 核心优势 ---------- */
    .section-adv {
      padding-top: 88px;
      padding-bottom: 96px;
      background: #ffffff;
      box-sizing: border-box;

      .adv-main {
        width: 1280px;
        margin: 0 auto;
      }

      .adv-grid {
        display: flex;
        justify-content: space-between;
        margin-top: 64px;
      }

      .adv-card {
        width: 240px;
        min-height: 220px;
        // 卡内文本左右 24px
        padding: 33px 24px 0;
        background: #f7f9fe;
        border-radius: 12px;
        box-sizing: border-box;

        .adv-icon {
          width: 48px;
          height: 48px;
          display: block;
        }

        .adv-title {
          margin-top: 24px;
          font-size: 24px;
          font-weight: 700;
          line-height: 36px;
          color: #1d1f24;
        }

        .adv-desc {
          margin-top: 14px;
          font-size: 14px;
          line-height: 21px;
          color: #8a8f9e;
        }
      }
    }

    /* ---------- 组网方案 ---------- */
    .section-plan {
      padding-top: 88px;
      padding-bottom: 104px;
      background: linear-gradient(180deg, #1d1f24 0%, #192238 100%);
      box-sizing: border-box;

      .plan-main {
        width: 1280px;
        margin: 0 auto;
      }

      .section-title {
        color: #ffffff;
      }

      .section-sub {
        // 深色区副标题保持 20px，只改颜色（基础 .section-sub 是 24px）
        font-size: 20px;
        line-height: 30px;
        color: rgba(255, 255, 255, 0.55);
      }

      .plan-grid {
        display: flex;
        justify-content: space-between;
        margin-top: 64px;
      }

      .plan-card {
        width: 302px;
        background: linear-gradient(
          180deg,
          rgba(38, 45, 66, 0.75) 0%,
          rgba(28, 34, 56, 0.5) 100%
        );
        border-radius: 16px;
        box-sizing: border-box;

        .plan-top {
          height: 220px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 16px 16px 0 0;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .plan-title {
          margin-top: 10px;
          margin-left: 29px;
          font-size: 24px;
          font-weight: 700;
          line-height: 34px;
          color: #ffffff;
          text-align: left;
        }

        .plan-desc {
          margin-top: 12px;
          margin-left: 29px;
          padding-right: 15px;
          font-size: 16px;
          line-height: 26px;
          color: rgba(255, 255, 255, 0.55);
          text-align: left;
          padding-bottom: 30px;
        }
      }
    }

    /* ---------- 应用场景 ---------- */
    .section-scene {
      padding-top: 88px;
      padding-bottom: 104px;
      background: #ffffff;
      box-sizing: border-box;

      .scene-main {
        width: 1280px;
        margin: 0 auto;
      }

      .scene-grid {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 50px;
      }

      .scene-card {
        width: 302px;
        margin-bottom: 24px;
        background: #ffffff;
        box-sizing: border-box;

        .scene-img-wrap {
          height: 180px;
          border-radius: 8px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .scene-title {
          margin-top: 20px;
          // 文本左右 12px，不写死宽度
          padding: 0 12px;
          font-size: 24px;
          font-weight: 700;
          line-height: 36px;
          color: #1d1f24;
        }

        .scene-desc {
          margin-top: 10px;
          // 文本左右 12px
          padding: 0 12px;
          font-size: 14px;
          line-height: 21px;
          color: #8a8f9e;
        }
      }
    }

    /* ---------- 底部 CTA ---------- */
    .section-cta {
      position: relative;
      padding-top: 62px;
      padding-bottom: 62px;
      background: #3772ff;
      overflow: hidden;
      box-sizing: border-box;

      .cta-overlay {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        mix-blend-mode: overlay;
        opacity: 0.6;
        pointer-events: none;
      }

      .cta-main {
        position: relative;
        width: 1280px;
        margin: 0 auto;
        text-align: center;
      }

      .cta-title {
        font-size: 40px;
        font-weight: 700;
        line-height: 60px;
        color: #ffffff;
      }

      .cta-sub {
        margin-top: 12px;
        font-size: 18px;
        color: #ffffff;
      }

      .cta-btn {
        margin: 28px auto 0;
        width: 168px;
        height: 48px;
        line-height: 48px;
        font-size: 19px;
        background: #ffffff;
        color: #3772ff;
      }
    }

    /* ---------- 滚动入场动画（同首页模式） ---------- */
    .move {
      opacity: 0;
      transform: translateY(50px);
      transition: opacity 0.8s ease-out, transform 0.8s ease-out;
    }
    .move-active {
      opacity: 1;
      transform: translateY(0);
    }
    /* 为不同元素设置不同的延迟，创建层次感 */
    .delay-100 {
      transition-delay: 0.1s;
    }
    .delay-200 {
      transition-delay: 0.2s;
    }
    .delay-300 {
      transition-delay: 0.3s;
    }
  }
</style>
